import React from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import WhatsappFlowConditionalSection from "./WhatsappFlowConditionalSection";
import {
  createEmptyConditionalMessage,
  normalizeConditionalMessages,
} from "./whatsappFlowConditional";

export default function WhatsappFlowConditionalMessagesSection({
  data,
  onPatch,
  fieldOptions = [],
  parameterOptions = [],
}) {
  const conditionalMessages = normalizeConditionalMessages(data?.conditionalMessages);

  const patchMessages = (nextMessages) => {
    onPatch({ conditionalMessages: normalizeConditionalMessages(nextMessages) });
  };

  const patchEntry = (index, nextEntry) => {
    const nextMessages = conditionalMessages.map((entry, i) =>
      i === index ? nextEntry : entry
    );
    patchMessages(nextMessages);
  };

  const addEntry = () => {
    patchMessages([...conditionalMessages, createEmptyConditionalMessage()]);
  };

  const removeEntry = (index) => {
    patchMessages(conditionalMessages.filter((_, i) => i !== index));
  };

  return (
    <Box>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ mb: 1 }}
      >
        <Typography variant="subtitle2" sx={{ color: "#161e55" }}>
          Mensajes condicionales adicionales
        </Typography>
        <Button
          size="small"
          startIcon={<AddCircleOutlineIcon />}
          onClick={addEntry}
          sx={{ textTransform: "none" }}
        >
          Agregar mensaje condicional
        </Button>
      </Stack>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Envía mensajes extra a distintos destinatarios cuando se cumplan las condiciones
        configuradas. Cada bloque debe completarse por completo antes de guardar.
      </Typography>

      {conditionalMessages.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          Sin mensajes condicionales. Usa «Agregar mensaje condicional» para crear uno.
        </Typography>
      ) : (
        <Stack spacing={2}>
          {conditionalMessages.map((entry, index) => (
            <WhatsappFlowConditionalSection
              key={entry.id}
              entry={entry}
              entryIndex={index}
              onPatchEntry={(nextEntry) => patchEntry(index, nextEntry)}
              onRemove={() => removeEntry(index)}
              fieldOptions={fieldOptions}
              parameterOptions={parameterOptions}
              showSyntaxHelp={index === conditionalMessages.length - 1}
            />
          ))}
        </Stack>
      )}
    </Box>
  );
}
